import { Navigate } from "react-router-dom";

function LoggedInOnly({ user, children }) {
  if (!user) return <Navigate to={"/login"} replace />;
  return children;
}

export default LoggedInOnly;
